module.exports = __webpack_public_path__ + "img/icon-edit.134c3a9e.svg";